export class ApiError extends Error {
  constructor(message, details = {}) {
    super(message);
    this.name = "ApiError";
    this.status = details.status ?? 0;
    this.detail = details.detail ?? "";
    this.method = details.method ?? "";
    this.url = details.url ?? "";
    this.payload = details.payload;
    this.cause = details.cause;
  }
}

export async function parseErrorResponse(res) {
  const contentType = res.headers.get("content-type") || "";
  let payload = null;
  let message = `Error ${res.status}`;

  try {
    if (contentType.includes("application/json")) {
      payload = await res.json();
      if (typeof payload?.detail === "string" && payload.detail.trim()) {
        message = payload.detail;
      } else if (typeof payload?.message === "string" && payload.message.trim()) {
        message = payload.message;
      }
    } else {
      const text = await res.text();
      if (text && text.trim()) {
        payload = text;
        message = text.slice(0, 300);
      }
    }
  } catch {
    // Keep generic error message.
  }

  return { message, payload };
}
